import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Button from "./button";
import RecordButton from "./record-button";
import StopButton from "./stop-button";
import Timer from "./timer";
import Countdown from "./countdown";
import { UploadIcon } from "@components/Icons/Upload";
import { EyeIcon } from "@components/Icons/EyeIcon";

const ActionsWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 35%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Actions = ({
  t,
  isVideoInputSupported,
  isInlineRecordingSupported,
  thereWasAnError,
  isRecording,
  isCameraOn,
  streamIsReady,
  isConnecting,
  isRunningCountdown,
  isReplayingVideo,
  countdownTime,
  timeLimit,
  showReplayControls,
  replayVideoAutoplayAndLoopOff,
  useVideoInput,

  onTurnOnCamera,
  onTurnOffCamera,
  onOpenVideoInput,
  onStartRecording,
  onStopRecording,
  onPauseRecording,
  onResumeRecording,
  onStopReplaying,
  onConfirm,
  onUpload,
  uploaded,
  showSubmitButton,
  uploading,
}) => {
  const renderContent = () => {
    const shouldUseVideoInput = !isInlineRecordingSupported && isVideoInputSupported;

    if (
      (!isInlineRecordingSupported && !isVideoInputSupported) ||
      thereWasAnError ||
      isConnecting ||
      isRunningCountdown
    ) {
      return null;
    }

    if (isReplayingVideo) {
      return (
        <div className="flex flex-col">
          {!uploaded && showSubmitButton && (
            <button disabled={uploading} className={`btn-primary btn mx-4`} onClick={onUpload}>
              {t("upload")}
            </button>
          )}
          {uploaded ? (
            <div className="flex flex-col items-center">
              {/* <button onClick={onStopReplaying} className={`btn-secondary btn mx-4 text-sm text-base-200`}>
                {t("goToPreview")}
                <EyeIcon className="ml-2 h-4 w-4" />
              </button>
              <p className="py-8 text-lg text-base-200">{t("or")}</p> */}
              <button onClick={onStopReplaying} className={`btn-seconray btn mx-4 text-sm text-base-200`}>
                {t("recordAnotherVideo")}
                <UploadIcon className="ml-2 h-4 w-4" />
              </button>
            </div>
          ) : (
            <button onClick={onStopReplaying} className={`btn-link btn mx-4 mt-12 text-base-200`}>
              {t("reuploadVideo")}
            </button>
          )}
        </div>
      );
    }

    if (isRecording) {
      return <StopButton type="button" onClick={onStopRecording} />;
    }

    if (isCameraOn && streamIsReady) {
      return <RecordButton t={t} type="button" onClick={onStartRecording} />;
    }

    if (useVideoInput) {
      return (
        <Button type="button" onClick={onOpenVideoInput}>
          {t("upload")}
        </Button>
      );
    }

    if (isConnecting) return <></>;

    return shouldUseVideoInput ? (
      <Button type="button" onClick={onOpenVideoInput}>
        {t("recordVideo")}
      </Button>
    ) : (
      <Button type="button" onClick={onTurnOnCamera}>
        {t("turnCameraOn")}
      </Button>
    );
  };

  return (
    <div>
      {isRecording && <Timer timeLimit={timeLimit} />}
      {isRunningCountdown && <Countdown countdownTime={countdownTime} />}
      <ActionsWrapper>{renderContent()}</ActionsWrapper>
    </div>
  );
};

Actions.propTypes = {
  t: PropTypes.func,
  isVideoInputSupported: PropTypes.bool,
  isInlineRecordingSupported: PropTypes.bool,
  thereWasAnError: PropTypes.bool,
  isRecording: PropTypes.bool,
  isCameraOn: PropTypes.bool,
  streamIsReady: PropTypes.bool,
  isConnecting: PropTypes.bool,
  isRunningCountdown: PropTypes.bool,
  countdownTime: PropTypes.number,
  timeLimit: PropTypes.number,
  showReplayControls: PropTypes.bool,
  replayVideoAutoplayAndLoopOff: PropTypes.bool,
  isReplayingVideo: PropTypes.bool,
  useVideoInput: PropTypes.bool,

  onTurnOnCamera: PropTypes.func,
  onTurnOffCamera: PropTypes.func,
  onOpenVideoInput: PropTypes.func,
  onStartRecording: PropTypes.func,
  onStopRecording: PropTypes.func,
  onPauseRecording: PropTypes.func,
  onResumeRecording: PropTypes.func,
  onStopReplaying: PropTypes.func,
  onConfirm: PropTypes.func,
  onUpload: PropTypes.func,
  uploaded: PropTypes.bool,
  showSubmitButton: PropTypes.bool,
};

export default Actions;
